import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchAllDoctors, fetchAllSpecialities, fetchFilterOPD, fetchDoctorsBySpeciality,
  searchDoctors, storeRequestCallback, fetchDoctorsBanner, fetchDoctorPageSeo
} from "../Adapter/PageAdapter";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { Toaster, toast } from 'sonner';
import SpecdetailBan from "../assets/images/Doctors-new.jpg";
import SearchBlk from "../assets/images/spciallites/searchblk.png";
import ShareVec from "../assets/images/speci-detail/sharevector.svg";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import newArrImg from "../assets/images/arrw.svg";
import userIcn from "../assets/images/doctor-profile.png";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";

// Helper function to limit text to a specific word count
const truncateWords = (text, wordLimit = 15) => {
  if (!text) return "";
  const words = text.split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : text;
};

const OurDoctors = () => {
  const [doctors, setDoctors] = useState([]); // All doctors
  const [searchTerm, setSearchTerm] = useState(""); // Search term
  const [selectedSpeciality, setSelectedSpeciality] = useState(""); // Selected specialty
  const [selectedSpecialityName, setSelectedSpecialityName] = useState("");
  const [pendingSpecialityId, setPendingSpecialityId] = useState(null);
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formloading, setFormLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const doctorsPerPage = 8;
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isManuallyOpened, setIsManuallyOpened] = useState(false);
  const [specialties, setSpecialties] = useState([]);
  const [doctorsList, setDoctorsList] = useState([]);
  const [seoData, setSeoData] = useState(null);
  const [isFilteredBySpeciality, setIsFilteredBySpeciality] = useState(false);
  const location = useLocation();

   useEffect(() => {
    const passedSpecialtyId = location.state?.selectedSpecialty;

    if (passedSpecialtyId) {
      setFormData((prev) => ({
        ...prev,
        speciality_id: String(passedSpecialtyId),
      }));

      // optionally load doctors
      fetchFilterOPD(passedSpecialtyId).then((response) => {
        if (response?.data) {
          setDoctorsList(response.data);
        }
      });

      // open modal if needed
      setShowModal(true);
      setIsManuallyOpened(true);
    }
  }, [location.state]);

  useEffect(() => {
    const handleSpecialityChange = (e) => {
      const specialityId = e.detail;
      console.log("Speciality ID from header click:", specialityId);
      setPendingSpecialityId(String(specialityId)); // store temporarily
    };

    window.addEventListener("speciality-selected", handleSpecialityChange);
    return () => window.removeEventListener("speciality-selected", handleSpecialityChange);
  }, []);

   useEffect(() => {
    if (pendingSpecialityId && specialties.length > 0) {
      const matched = specialties.find(s => String(s.id) === String(pendingSpecialityId));
      const specialityName = matched?.name || "";

      console.log("Resolved name from specialties:", specialityName);

      if (specialityName) {
        setSelectedSpeciality(pendingSpecialityId);
        setSelectedSpecialityName(specialityName);
        handleSpecialtyList(pendingSpecialityId);
        setPendingSpecialityId(null); // clear after use
      }
    }
  }, [pendingSpecialityId, specialties]);


  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchDoctorPageSeo...");
        const res = await fetchDoctorPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchDoctorPageSeo);

  useEffect(() => {
    const fetchData = async () => {
      const bannerResponse = await fetchDoctorsBanner();
      if (bannerResponse && bannerResponse.data) {
        setBannerData(bannerResponse.data);
      }
    };

    fetchData();
  }, []);

  // Fetch all doctors on component mount
  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetchAllDoctors();
        if (response && response.data) {
          setDoctors(response.data);
          setDoctorsList(response.data);
        }
      } catch (error) {
        console.error("Error fetching doctors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDoctors();
  }, []);

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const response = await fetchAllSpecialities();
        if (response && response.specialities) {
        //  setSpecialties(response.specialities.sort((a, b) => a.name.localeCompare(b.name)));
	const sorted = response.specialities.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setSpecialties(sorted);
        }
      } catch (error) {
        console.error("Error fetching specialties:", error);
      }
    };
    fetchSpecialties();
  }, []);

  const handleSpecialtyList = async (eventOrId, preselectedDoctorId = "") => {
    let specialityId = "";

    if (typeof eventOrId === "object" && eventOrId !== null && eventOrId.target) {
      // Called via user input
      specialityId = eventOrId.target.value;
    } else {
      // Called programmatically with ID
      specialityId = eventOrId;
    }

    const selectedSpeciality = specialties.find(
    (item) => String(item.id) === String(specialityId)
     );
    const selectedSpecialityName = selectedSpeciality ? selectedSpeciality.name : "";


    setFormData((prev) => ({
      ...prev, 
      speciality_id: specialityId,
      speciality: specialityId,
      speciality_name: String(selectedSpecialityName),
    //  doctor: "",
      doctor: "",
      doctor_name: "",
    }));

    try {
      const response = await fetchFilterOPD(specialityId);
      if (response && response.data) {
        setDoctorsList(response.data);

      //  if (preselectedDoctorId) {
      //    setFormData((prev) => ({
      //      ...prev,
      //     doctor: preselectedDoctorId,
      //    }));
      //   } 
	      
	 if (preselectedDoctorId) {
        const selectedDoctor = response.data.find(
        (doc) => String(doc.doctor_id) === String(preselectedDoctorId)
       );

      setFormData((prev) => ({
         ...prev,
        doctor: preselectedDoctorId,
        doctor_name: selectedDoctor?.name || "",
      }));
     }

         }
	
         else {
        setDoctorsList([]);
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

 // useEffect(() => {
 //   if (!isManuallyOpened) {  // Only trigger the timer if not manually opened
 //     const timer = setTimeout(() => {
 //       setShowModal(true);
 //     }, 15000);

 //     return () => clearTimeout(timer); // Cleanup timer on component unmount
 //   }
 // }, [isManuallyOpened]);  

   useEffect(() => {
  if (!isManuallyOpened) {
    const timer = setTimeout(() => {
      setFormData((prev) => ({
        ...prev,
        speciality_id: prev.speciality_id || "",
        doctor: "",
	doctor_name: ""
      }));
      setShowModal(true);
    }, 15000);

    return () => clearTimeout(timer);
  }
}, [isManuallyOpened]);


  // Handle search form submission
  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await searchDoctors(searchTerm);
      if (response && response.data) {
        setDoctors(response.data);
        setDoctorsList(response.data);    // filtered for form dropdowns
        setCurrentPage(1);
      } else {
        setDoctors([]);
        setDoctorsList([]);
      }
    } catch (error) {
      console.error("Error searching doctors:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDoctorClick = (id, name, slug) => {
    const formattedName = slug.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
    localStorage.setItem("doctorId", id); // Store the ID in localStorage
    navigate(`/doctor/${formattedName}`);
  };

  // Handle Share Click
  const handleShare = (doctor) => {
    const doctorProfileUrl = `${window.location.origin}/doctor/${doctor.slug}`;
    if (navigator.share) {
      navigator
        .share({
          title: `Check out Dr. ${doctor.name}`,
          text: `Learn more about Dr. ${doctor.name}, a specialist in ${doctor.speciality}.`,
          url: doctorProfileUrl,
        })
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  const [formData, setFormData] = useState({
    patient_name: "",
    contact_number: "",
    email: "",
    message: "",
    appointment_date: "",
    doctor_id: "",
    doctor_name: "",
    speciality_id: "",
    speciality_name: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Only allow numbers and plus in contactNo
    if (name === "contactNo" || name === "countryCode") {
      const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
      setFormData({ ...formData, [name]: sanitizedValue });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleOpenModal = (doctor) => {
    const parsedSpecialityIds = Array.isArray(doctor.speciality_ids)
      ? doctor.speciality_ids
      : (() => {
          try {
            const decoded = JSON.parse(doctor.speciality_id);
            return Array.isArray(decoded) ? decoded : [];
          } catch (error) {
            return [];
          }
        })();

    let specialityId = "";
    if (parsedSpecialityIds.length > 0) {
      specialityId = String(parsedSpecialityIds[0]);
    } else if (doctor.speciality_id && !String(doctor.speciality_id).startsWith("[")) {
      specialityId = String(doctor.speciality_id);
    }

    const specialityName =
      doctor.speciality_names?.[0] ||
      (typeof doctor.speciality === "string"
        ? doctor.speciality
        : specialties.find(
            (spec) =>
              spec.name.toLowerCase().trim() ===
              String(doctor.speciality || "").toLowerCase().trim()
          )?.name || "");

    setFormData((prev) => ({
      ...prev,
      doctor: doctor.id,
      doctor_id: doctor.doctor_id,
      speciality_id: specialityId,
      speciality: specialityId,
      doctor_name: doctor.name,
     // speciality_name: doctor.speciality,
      speciality_name: specialityName,

    }));

    // ✅ Show only the selected doctor in dropdown
    setDoctorsList([{
     // id: doctor.doctor_id,
      id: String(doctor.doctor_id),    
      name: doctor.name
    }]);

    setShowModal(true);
    setIsManuallyOpened(true);
  };


  const handleCloseModal = () => {
    setShowModal(false);

    // Manually remove Bootstrap modal-related classes
    document.body.classList.remove("modal-open");

    // Remove the modal backdrop if it exists
    const modalBackdrops = document.getElementsByClassName("modal-backdrop");
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formloading) return;

    setFormLoading(true);

    const payload = {
      patient_name: formData.patientName,
      contact_number: formData.contactNo,
      email: formData.email,
      message: formData.message,
      appointment_date: formData.date,
      doctor_id: formData.doctor_id || formData.doctor,
     /// speciality_id: formData.speciality,
      speciality_id: formData.speciality_id,
      doctor_name: formData.doctor_name,
      speciality_name: String(formData.speciality_name || ""),
    };

    const crmPayload = {
      first_name: payload.patient_name?.split(" ")[0],
      last_name: payload.patient_name?.split(" ")[1] || "",
      phone: payload.contact_number,
      email: payload.email,
      message: payload.message,
      source: "Doctor List Page Form",
      fortis_doctor_name: payload.doctor_name,
      referred_for_specilaity: String( payload.speciality_name || ""),
    //  referred_for_specilaity: formData.speciality_name || "",
      expected_admission_date: payload.appointment_date,
    };

    try {
      const { backendResult, crmResult } = await storeRequestCallback(payload);

      // if (isBackendSuccess && isCrmSuccess) {
      if (
        (backendResult?.status === "true" || backendResult?.status === true) &&
        crmResult?.message
      ) {
        toast.success("Request submitted successfully!");
        setFormData({
          patientName: "",
          contactNo: "",
          email: "",
          message: "",
          date: "",
          doctor: "",
          doctor_name: "",
          speciality: "",
          speciality_name: ""
        });
        setDoctorsList([]);
        handleCloseModal();
      } else {
        toast.success("Request submitted successfully!");
      }
    } catch (error) {
      console.error("Error submitting request:", error);
      toast.error("An error occurred. Please try again.");
    }
    finally {
      setFormLoading(false);
    }
  };

 //  const filteredDoctors = doctors.filter(
 //   (doctor) =>
 //     (!selectedSpeciality || doctor.speciality === selectedSpeciality) &&
 //     (!searchTerm || doctor.name.toLowerCase().includes(searchTerm.toLowerCase()))
 //  );

 //  const filteredDoctors = doctors.filter(
 //   (doctor) =>
 //     (!selectedSpeciality || String(doctor.speciality_id) === String(selectedSpeciality)) &&
 //     (!searchTerm || doctor.name.toLowerCase().includes(searchTerm.toLowerCase()))
 //  ); 
 const filteredDoctors = doctors.filter(
  (doctor) =>
    (!selectedSpeciality ||
      doctor.speciality_ids?.map(String).includes(String(selectedSpeciality))) &&
    (!searchTerm || doctor.name.toLowerCase().includes(searchTerm.toLowerCase()))
  );


  const getVisiblePages = () => {
    const totalVisible = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + totalVisible - 1);

    if (end - start < totalVisible - 1) {
      start = Math.max(1, end - totalVisible + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Pagination Logic
  const indexOfLastDoctor = currentPage * doctorsPerPage;
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
  const currentDoctors = filteredDoctors.slice(indexOfFirstDoctor, indexOfLastDoctor);
  const totalPages = Math.ceil(filteredDoctors.length / doctorsPerPage);

  if (loading) {
    return <p>Loading doctors...</p>;
  }

  return (
    <>
      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}
      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {bannerData && bannerData[0]?.img_path ? (
              <img
                src={`${baseImage_path}${bannerData[0].img_path.replace('.', '')}`}
                alt={bannerData[0].banner_heading || "Doctors"}
              />
            ) : (
              <img src={SpecdetailBan} alt="Doctors" />
            )}
            <div className="ban-con">
              <h1>{bannerData[0]?.banner_heading || 'Doctors'}</h1>
            </div>
          </div>
        </div>
      </section>

      <Toaster position="top-right" />

      {/* Search Section */}
      <section className="our-exper-doctrors-sec mrgntop70">
        <div className="cust-container">
          <div className="row">
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
              <div className="finnest host-det">
                <h4>Our Expert Doctors</h4>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
              <div className="specialty-search-items">
                <div className="specialty-search add-right-margn">
                  <form className="example" onSubmit={handleSearch}>
                    <input
                      type="text"
                      placeholder="Search by Doctors Name"
                      name="search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button type="submit">
                      <img src={SearchBlk} alt="Search Icon" />
                    </button>
                  </form>
                </div>
                <div className="specialty-search add-left-mrgn">
	  {/*  <form className="example">
                    <select
                      value={selectedSpeciality}
                      onChange={(e) => setSelectedSpeciality(e.target.value)}
                    >
                      <option value="">All Specialities</option>
                      {[...new Set(doctors.map((doctor) => doctor.speciality))].map(
                        (speciality, index) => (
                          <option key={index} value={speciality}>
                            {speciality}
                          </option>
                        )
                      )}
                    </select>
                  </form>  */}
	      <form className="example">
                    <select
                      value={selectedSpeciality}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        setSelectedSpeciality(selectedId);

                        const selected = specialties.find(s => String(s.id) === selectedId);
                        setSelectedSpecialityName(selected?.name || "");

                        handleSpecialtyList(selectedId);
                      }}
                    >
                      <option value="">All Specialities</option>
                      {specialties.map((specialty) => (
                        <option key={specialty.id} value={specialty.id}>
                          {specialty.name}
                        </option>
                      ))}
                    </select>
                  </form>
                
	  
                </div>
              </div>
            </div>
          </div >
        </div >
      </section >

      {/* Doctors Card Section */}
      < section
        className="our-expert-cardiologist-sec mrgntop70 margnbot90"
        id="expert-cardiologistid" style={{ marginTop: "20px" }}
      >
        <div className="cust-container">
          <div className="row">
            {currentDoctors.length > 0 ? (
              currentDoctors
		                  .map((doctor) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                    key={doctor.id}
                  >
                    <div
                      className="oueextpert-cardiolo-item"
                      onClick={() => handleDoctorClick(doctor.id, doctor.name, doctor.slug)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="cardiolo-item-img">
                        <img
                          src={
                            doctor.img_path
                              ? `${baseImage_path}/${doctor.img_path}`
                              : `${userIcn}`
                          }
                          alt={doctor.name}
                        />
                      </div>
                      <div className="cardiolo-itemdesc">
                        <div className="drs-design">
			{/*  <span>{doctor.speciality}</span>  */}
			<span> {doctor.speciality_names?.[0] || "Speciality"} </span>
                          <button
                            style={{ background: "transparent", color: "#0ca854", fontSize: "12px", fontWeight: "500" }}>
                            View Profile
                          </button>
                        </div>
                        <div className="drs-title">
                          <h4>{doctor.name_prefix} {doctor.name}</h4>
                          <div className="drs-title-shareicn">
                            <img
                              onClick={(e) => { e.stopPropagation(); handleShare(doctor); }}
                              src={ShareVec}
                              alt="Share Icon"
                              style={{ cursor: "pointer" }} />
                          </div>
                        </div>
                        <p>
                          Total Experience - {doctor.experience ? doctor.experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                        </p>
                        <div className="drs-bookapp-cta common-roundcta">
                          <button className="btnhv" onClick={(e) => { e.stopPropagation(); handleOpenModal(doctor); }}>
                            Book Appointment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="col-12 text-center">
                <p>No doctors found for the given search criteria.</p>
              </div>
            )}
          </div>
	  {/*  <div className="pagination">
            <button disabled={currentPage === 1} onClick={() => {
              setCurrentPage(currentPage - 1);
              window.scrollTo({ top: 100, behavior: 'smooth' });
            }}
            ><ArrowBackIosIcon /></button>
            {[...Array(totalPages)].map((_, index) => (
              <button key={index} onClick={() => {
                setCurrentPage(index + 1);
                window.scrollTo({ top: 100, behavior: 'smooth' });
              }} className={currentPage === index + 1 ? 'active' : ''} style={{ width: "25px" }}>
                {index + 1}
              </button>
            ))}
            <button disabled={currentPage === totalPages} onClick={() => {
              setCurrentPage(currentPage + 1);
              window.scrollTo({ top: 100, behavior: 'smooth' });
            }} style={{ width: "25px" }}><ArrowForwardIosIcon /></button>
          </div>  */}

	  <div className="pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => {
                setCurrentPage(currentPage - 1);
                window.scrollTo({ top: 100, behavior: 'smooth' });
              }}
            >
              <ArrowBackIosIcon />
            </button>

            {currentPage > 3 && (
              <>
                <button onClick={() => setCurrentPage(1)}>1</button>
                <span>...</span>
              </>
            )}

            {getVisiblePages().map((page) => (
              <button
                key={page}
                onClick={() => {
                  setCurrentPage(page);
                  window.scrollTo({ top: 100, behavior: 'smooth' });
                }}
                className={currentPage === page ? 'active' : ''}
              >
                {page}
              </button>
            ))}

            {currentPage < totalPages - 2 && (
              <>
                <span>...</span>
                <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
              </>
            )}

            <button
              disabled={currentPage === totalPages}
              onClick={() => {
                setCurrentPage(currentPage + 1);
                window.scrollTo({ top: 100, behavior: 'smooth' });
              }}
            >
              <ArrowForwardIosIcon />
            </button>
          </div>
        </div>
      </section >

      {/* Modal for patient form */}
      {showModal && (
        <div
          className="modal fade custmodal-width custom-modalwdth2 show"
          style={{ display: "block" }}
          id="patienform"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalclosebtn">
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="intern-form-inner">
                  <h5>Request A Call Back Form:</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="patientName">
                            Name of the Patient <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="patientName"
                            name="patientName"
                            value={formData.patientName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="int-form-item">
                          <label htmlFor="contactNo">
                            Contact No <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="contactNo"
                            name="contactNo"
                            value={formData.contactNo}
                            onChange={handleInputChange}
                            pattern="^\+?[0-9]*$"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="email">Email</label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
	      {/*   <label htmlFor="speciality">Speciality <span>*</span></label>
                          <select
                            id="speciality"
                            name="speciality"
                            value={formData.speciality}
                            onChange={handleSpecialtyList}
                          >
                            <option value="">Please select Speciality</option>
                            {specialties.map((specialty) => (
                              <option key={specialty.id} value={specialty.id}>
                                {specialty.name}
                              </option>
                            ))}
                          </select>  */}
	      {/*  <label htmlFor="speciality">Speciality</label>
                          <input
                            type="text"
                            id="speciality"
                            name="speciality_name"
                            value={formData.speciality_name || ""}
                            readOnly
                          />
                         
                          <input
                            type="hidden"
                            name="speciality_id"
                            value={formData.speciality_id || ""}
                          />  */}
	      {isManuallyOpened ? (
  <>
    <label htmlFor="speciality">Speciality</label>
    <input
      type="text"
      id="speciality"
      name="speciality_name"
      value={formData.speciality_name || ""}
      readOnly
    />
    <input
      type="hidden"
      name="speciality_id"
      value={formData.speciality_id || ""}
    />
  </>
) : (
  <>
    <label htmlFor="speciality">Speciality <span>*</span></label>
    <select
      id="speciality"
      name="speciality_id"
      value={String(formData.speciality_id || ""  )}
      onChange={(e) => handleSpecialtyList(e)}
      required
    >
      <option value="">Please select Speciality</option>
      {specialties.map((specialty) => (
        <option key={specialty.id} value={specialty.id}>
          {specialty.name}
        </option>
      ))}
    </select>
  </>
)}


                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
	      {/*  <label htmlFor="doctor">Select Doctor <span>*</span></label>
                          <select
                            id="doctor"
                            name="doctor"
                            value={String(formData.doctor)}
                            onChange={(e) => setFormData({ ...formData, doctor: e.target.value })}
                          >
                            <option value="">Please select Doctor</option>
                            {doctorsList.map((doctor) => (
                              <option key={doctor.id} value={String(doctor.id)}>
                                {doctor.doctor_name}
                              </option>
                            ))}
                          </select>  */}
	      {/*   <label htmlFor="doctor">Doctor</label>
                          <input
                            type="text"
                            id="doctor"
                            name="doctor_name"
                            value={formData.doctor_name || ""}
                            readOnly
                          />
                         
                          <input
                            type="hidden"
                            name="doctor_id"
                            value={formData.doctor || ""}
                          /> */}  
	                 {isManuallyOpened ? (
  <>
    <label htmlFor="doctor">Doctor</label>
    <input
      type="text"
      id="doctor"
      name="doctor_name"
      value={formData.doctor_name || ""}
      readOnly
    />
    <input
      type="hidden"
      name="doctor_id"
      value={formData.doctor || ""}
    />
  </>
) : (
  <>
    <label htmlFor="doctor">Select Doctor <span>*</span></label>
    <select
      id="doctor"
      name="doctor"
      value={String(formData.doctor_id || "" )}
    //  onChange={(e) => setFormData({ ...formData, doctor: e.target.value })}  
       onChange={(e) => {
    const selectedDoctorId = e.target.value;
    const selectedDoctor = doctorsList.find(doc => String(doc.doctor_id) === String(selectedDoctorId));
    setFormData({
      ...formData,
      doctor_id: Number(selectedDoctorId),
      doctor_name: selectedDoctor?.doctor_name || selectedDoctor?.name || "",
    });
  }}

      required
    >
      <option value="">Please select Doctor</option>
      {doctorsList.map((doctor) => (
        <option key={doctor.id} value={doctor.doctor_id}>
          {doctor.doctor_name || doctor.name}
        </option>
      ))}
    </select>
  </>
)}

                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="date">Please Select Date <span>*</span></label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split("T")[0]}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="message">Message</label>
                          <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleInputChange}
                            rows="5"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <div className="int-form-item">
                          <button type="submit" disabled={formloading}>
                            {formloading ? (
                              <>
                                <img src={newArrImg} alt="" className="spin" />
                                Sending...
                              </>
                            ) : (
                              <>
                                <img src={newArrImg} alt="" />
                                Submit
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default OurDoctors;
